import { render, staticRenderFns } from "./RelMembros.vue?vue&type=template&id=0beba9f4"
import script from "./RelMembros.vue?vue&type=script&lang=js"
export * from "./RelMembros.vue?vue&type=script&lang=js"
import style0 from "./RelMembros.vue?vue&type=style&index=0&id=0beba9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports